import { GUEST_FAV_GAMES_KEY, GUEST_LAST_PLAYED_KEY } from "./guestGames";

const REMEMBER_ME_KEY = "rememberMeCredentials";
const REMEMBER_ME_ENABLED_KEY = "rememberMeEnabled";
const FINGERPRINT_KEY = "inversa_fingerprint_id";

/** Keys that must survive logout / full storage clears. */
const PRESERVED_KEYS = [
  REMEMBER_ME_KEY,
  REMEMBER_ME_ENABLED_KEY,
  FINGERPRINT_KEY,
  GUEST_FAV_GAMES_KEY,
  GUEST_LAST_PLAYED_KEY,
];

/**
 * Remember-me preference of the last login. Drives session lifetime:
 * enabled -> persistent auth cookies, disabled -> the session ends with the tab.
 */
export function isRememberMeEnabled() {
  try {
    return localStorage.getItem(REMEMBER_ME_ENABLED_KEY) === "true";
  } catch {
    return false;
  }
}

export function setRememberMePreference(enabled) {
  try {
    if (enabled) {
      localStorage.setItem(REMEMBER_ME_ENABLED_KEY, "true");
    } else {
      localStorage.removeItem(REMEMBER_ME_ENABLED_KEY);
    }
  } catch {
    // localStorage may be unavailable
  }
}

export function getRememberedCredentials() {
  try {
    const raw = localStorage.getItem(REMEMBER_ME_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const username =
      typeof parsed.username === "string" ? parsed.username.trim() : "";
    if (!username) return null;
    return { username, rememberMe: true };
  } catch {
    return null;
  }
}

export function saveRememberedCredentials({ username } = {}) {
  const trimmed = typeof username === "string" ? username.trim() : "";
  if (!trimmed) {
    clearRememberedCredentials();
    return;
  }
  try {
    localStorage.setItem(
      REMEMBER_ME_KEY,
      JSON.stringify({ username: trimmed })
    );
  } catch {
    // localStorage may be unavailable
  }
}

export function clearRememberedCredentials() {
  try {
    localStorage.removeItem(REMEMBER_ME_KEY);
    localStorage.removeItem(REMEMBER_ME_ENABLED_KEY);
  } catch {
    // localStorage may be unavailable
  }
}

/**
 * Clears localStorage while keeping remember-me + device fingerprint.
 * Use this instead of localStorage.clear() on logout / session reset.
 */
export function clearLocalStoragePreservingAppKeys() {
  try {
    const preserved = {};
    for (const key of PRESERVED_KEYS) {
      const value = localStorage.getItem(key);
      if (value != null) preserved[key] = value;
    }
    localStorage.clear();
    for (const [key, value] of Object.entries(preserved)) {
      localStorage.setItem(key, value);
    }
  } catch {
    // localStorage may be unavailable
  }
}
